import {
  ChangeDetectionStrategy,
  Component,
  forwardRef,
  input,
  linkedSignal,
  OnDestroy,
  OnInit,
  output
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { TimeParser } from '../../../services/time.parser';
import { UserAgentService } from '../../../services/user-agent.service';
import { CommonModule } from '@angular/common';
import { L10nModule } from '../../../l10n/l10n.module';
import { I18nModule } from '../../../i18n/i18n.module';
import { IsoTime } from '@softline/core';

@Component({
    selector: 'soft-time-input',
    imports: [CommonModule, L10nModule, I18nModule],
    templateUrl: './time-input.component.html',
    styleUrls: ['./time-input.component.css'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => TimeInputComponent),
            multi: true,
        },
    ],
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: {
      '[class.readonly]': 'readonly()'
    }
})
export class TimeInputComponent
  implements OnInit, OnDestroy, ControlValueAccessor
{
  format = input<string | null | undefined>(undefined);
  valueInput = input<IsoTime | null | undefined>(undefined, { alias: 'value' });

  value = linkedSignal(() => {
    return this.valueInput() ?? null;
  });
  valueChange = output<IsoTime | null>();

  placeholder = input<string | null>(null);
  disableInput = input<boolean>(false);
  readonly = input<boolean>(false);
  inputClass = input<string>('');

  // tslint:disable:no-empty
  private onChange: Function = () => {};
  onTouch: Function = () => {};

  constructor(
    readonly userAgentService: UserAgentService,
    private isoTimeParser: TimeParser<any>
  ) {}

  ngOnInit(): void {}

  ngOnDestroy(): void {}

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }

  writeValue(obj: any): void {
    this.value.set(obj);
  }

  setValue(value: string): void {
    if (!value)
      this.value.set(null);
    else
      this.value.set(this.isoTimeParser.parse(value));
    this.onChange(this.value());
    this.valueChange.emit(this.value());
  }
}
